import Column from '@components/column'
import CardHeading from '@commons/headings/card'
import Empty from '@commons/empty'
import { StyleGrid, StyleGridItem } from './style'
import Image from '@components/image'
import { Fragment } from 'react/jsx-runtime'
const AppointmentReports = ({ reports }: any) => {
  const handleClick = async (event) => {
    const target = event.target as HTMLElement
    const cross = target.closest('[data-cross-url]')
    if (!!cross) {
      const url = cross.getAttribute('data-cross-url')
      window.open(url, '_blank')
    }
  }
  return (
    <Column
      bg="white"
      styleColumn="padding:20px;border-radius:12px;"
      rowGap={15}
    >
      <CardHeading title="Patient Reports" tc="primary" />
      {!!reports?.length ? (
        <StyleGrid onClick={handleClick}>
          {reports?.map((report: any) => {
            const extension = report?.file?.split('.').pop()
            const fileUrl = `${process.env.BUCKET_URL}/${report?.file}`
            return (
              <Fragment key={report?.id}>
                <StyleGridItem
                  data-cross-url={`${process.env.BUCKET_URL}/${report?.file}`}
                >
                  {extension == 'pdf' ? <></> : <Image src={fileUrl} />}
                </StyleGridItem>
              </Fragment>
            )
          })}
        </StyleGrid>
      ) : (
        <Empty />
      )}
    </Column>
  )
}
export default AppointmentReports
